import type { DocumentType } from "@/types/domain";

/**
 * Convert a document type key like "bill_of_lading" to "Bill of Lading".
 * If a label map from /api/document-types is provided, use its label;
 * otherwise fall back to title-casing the key.
 */
export function formatDocumentType(
  key: string,
  types: DocumentType[] | undefined,
): string {
  const match = types?.find((t) => t.key === key);
  if (match) return match.label;
  return key
    .split("_")
    .map((part) => (part.length ? part[0]!.toUpperCase() + part.slice(1) : ""))
    .join(" ");
}
